import { Type } from '@angular/core';
import { Observable } from 'rxjs';

export interface OmniSearchResult<T = any> {
  title: string;
  description?: string;
  data: T;
}

export interface OmniSearchResultComponent<T = any> {
  data: T;
  providerId: string;
}

export interface OmniSearchProvider<T = any> {
  id: string;
  label: string; // e.g., "Search for client"
  description?: string; // hover/help tooltip text
  rolesAllowed: string[];
  subApp: string; // e.g., "BrightAI"
  shortcut?: string; // e.g., "@client", "/conversation"
  search(query: string): Observable<OmniSearchResult<T>[]>;
  loadComponent: () => Promise<Type<OmniSearchResultComponent<T>>>;
}
